$('.img-resize').resizeToParent();